/**
 * Returns a deep copy of a payment/order payload with PCI-sensitive fields masked for logging.
 * Masks: payment.ccNum (last 4 only), payment.cvcValue, payment.ccExpMonth, payment.ccExpYear, payment.ccNameOnCard.
 */
export function maskPaymentPayload(payload: any): any {
  if (payload == null) return payload;
  const masked = { ...payload };
  if (payload.payment && typeof payload.payment === 'object') {
    masked.payment = { ...payload.payment };
    if (payload.payment.ccNum != null && payload.payment.ccNum !== '') {
      const str = String(payload.payment.ccNum);
      masked.payment.ccNum = str.length <= 4 ? '****' : '****' + str.slice(-4);
    }
    if (payload.payment.cvcValue != null && payload.payment.cvcValue !== '') {
      masked.payment.cvcValue = '***';
    }
    if (payload.payment.ccExpMonth != null && payload.payment.ccExpMonth !== '') {
      masked.payment.ccExpMonth = '**';
    }
    if (payload.payment.ccExpYear != null && payload.payment.ccExpYear !== '') {
      masked.payment.ccExpYear = '****';
    }
    if (payload.payment.ccNameOnCard != null && payload.payment.ccNameOnCard !== '') {
      masked.payment.ccNameOnCard = '****';
    }
  }
  return masked;
}

/**
 * Returns a safe summary of a purchase contract success response for logging (no PCI).
 */
export function maskPurchaseContractResponse(order: any): any {
  if (order?.data?.[0]) {
    return {
      orderId: order.data[0].orderId,
      viewContractId: order.data[0].viewContractId != null ? '[present]' : undefined,
      contractId: order.data[0].contractId != null ? '[present]' : undefined,
      productCategory: order.data[0].productCategory,
    };
  }
  return { summary: 'no data' };
}
